// SupportSection.jsx
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaRocket, FaBook, FaTshirt } from 'react-icons/fa';
import { IoDocumentText } from 'react-icons/io5';
import '../../../assets/css/student/solutions/SolutionsSec.css';

const SolutionSection = () => {
  return (
    <>
      {/* Section 1: Support for Students with Image */}
      <section className="support-section">
        <Container>
          <Row className="align-items-center">
            {/* Left Column - Content */}
            <Col lg={6} md={12} className="mb-4 mb-lg-0">
              <p className="education-tag">EDUCATION</p>
              <h2 className="support-heading">Support for Students</h2>
              <p className="support-description">
                We provide financial and material support to help students continue their education.
              </p>
              
              {/* Checklist */}
              <ul className="support-list">
                <li>
                  <span className="check-icon">✓</span>
                  School & college fees
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Books & stationery
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Uniform assistance
                </li>
              </ul>
            </Col>

            {/* Right Column - Image */}
            <Col lg={6} md={12}>
              <div className="library-image-wrapper">
                <img 
                  src="https://t3.ftcdn.net/jpg/01/43/11/00/360_F_143110026_C4EmjmmVVYlcXpTtmCwil5Xv0wSfVCrY.jpg" 
                  alt="Library" 
                  className="library-image"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section 2: Our Mission and Our Programs */}
      <section className="mission-programs-section">
        <Container>
          <Row>
            {/* Our Mission */}
            <Col lg={6} md={12} className="mb-4 mb-lg-0">
              <div className="mission-card">
                <div className="icon-box">
                  <FaRocket size={30} color="#ffffff" />
                </div>
                
                <h3 className="card-heading">Our Mission</h3>
                
                <p className="card-description">
                  No student should miss education due to finances.
                </p>
                
                <Button className="learn-more-btn">
                  Learn More →
                </Button>
              </div>
            </Col>

            {/* Our Programs */}
            <Col lg={6} md={12}>
              <div className="programs-card">
                <h3 className="card-heading">Our Programs</h3>
                
                {/* Programs List */}
                <div className="programs-list">
                  {/* Books & Supplies */}
                  <div className="program-item">
                    <div className="program-icon-box">
                      <FaBook size={22} color="#ffffff" />
                    </div>
                    <div>
                      <h5 className="program-title">Books & supplies</h5>
                    </div>
                  </div>

                  {/* Clothing for Students */}
                  <div className="program-item">
                    <div className="program-icon-box">
                      <FaTshirt size={22} color="#ffffff" />
                    </div>
                    <div>
                      <h5 className="program-title">Clothing for students</h5>
                    </div>
                  </div>

                  {/* Tuition Coverage */}
                  <div className="program-item">
                    <div className="program-icon-box">
                      <IoDocumentText size={22} color="#ffffff" />
                    </div>
                    <div>
                      <h5 className="program-title">Tuition coverage</h5>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SolutionSection;